<template>
  <v-row>
    <v-col class="px-0">
      <v-card>
        <v-card-title>
          <span class="pr-1">Grupos de produtos aceleradores</span>

          <v-tooltip bottom max-width="300px">
            <template v-slot:activator="{ on }">
              <span v-on="on">
                <mf-icon class="help-icon pb-1" size="18">info</mf-icon>
              </span>
            </template>
            <span>Grupos de produtos que irão conceder números da sorte extras.</span>
          </v-tooltip>

          <v-spacer />
          <product-group-dialog v-if="!isConfirm" @save="addProductGroup" />
          <div class="pr-3"></div>
          <mf-search v-model="search" dense width="400" hide-details placeholder="Busque um grupo" />
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-data-table fixed-header :options.sync="options" :items="items" :headers="headers" no-data-text="Não há grupos neste sorteio.">
                <template v-slot:[`item.image_url`]="{ item }">
                  <v-img :src="item.image_url" contain height="40px" class="td-img" />
                </template>
                <template v-slot:[`item.products`]="{ item }">
                  <span>{{ item.products.length }}</span>
                </template>
                <template v-slot:[`item.trigger_value`]="{ item }">
                  <span>{{ item.trigger_value | localeString(2) | currency }}</span>
                </template>
                <template v-slot:[`item.max_per_coupon_value`]="{ item }">
                  <span>{{ item.max_per_coupon_value || 'Ilimitado' }}</span>
                </template>
                <template v-slot:[`item.active`]="{ item }">
                  <span>{{ item.active ? 'Ativo' : 'Inativo' }}</span>
                </template>
                <template v-slot:[`item.menu`]="{ item }">
                  <v-menu v-if="!isConfirm" bottom origin="center center" transition="scale-transition">
                    <template v-slot:activator="{ on }">
                      <mf-button type="icon" icon="more_vert" color="cinza-0" v-on:click.native="on.click" />
                    </template>
                    <v-list>
                      <v-list-item @click="editItem(item)">
                        <v-list-item-title>Editar</v-list-item-title>
                      </v-list-item>
                      <v-list-item :disabled="isDisabled" @click="removeItem(item)">
                        <v-list-item-title>Remover</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-data-table>
              <product-group-dialog v-model="isEditingProduct" :product-group="selectedProductGroup" is-edit @save="editProductGroup" /> </v-col
          ></v-row>
          <p v-if="error" class="error--text error-text my-2 pa-2">É necessário adicionar ao menos um grupo de produtos para ativar ou agendar um sorteio.</p>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ProductGroupDialog from './ProductGroupDialog'
import { diacriticSpaceSensitiveRegex } from '@/helpers/search.js'
export default {
  name: 'ParticipatingProductGroups',
  components: {
    ProductGroupDialog,
  },
  props: {
    productGroups: {
      type: Array,
    },
    isConfirm: {
      type: Boolean,
    },
    isDisabled: {
      type: Boolean,
    },
    error: {
      type: Boolean,
    },
  },
  data: () => ({
    search: '',
    isEditingProduct: false,
    selectedProductGroup: {},
    localProductGroups: [],
    options: {},
  }),
  computed: {
    headers() {
      return [
        {
          text: '',
          value: 'image_url',
          sortable: false,
          width: '5%',
        },
        {
          text: 'Nome do grupo',
          value: 'name',
          width: '25%',
        },
        {
          text: 'Produtos',
          value: 'products',
          width: '10%',
        },
        {
          text: 'Valor para creditar números',
          value: 'trigger_value',
          width: '15%',
        },
        {
          text: 'Números extras',
          value: 'acceleration_value',
          width: '15%',
        },
        {
          text: 'Máximo de números extras por compra',
          value: 'max_per_coupon_value',
          width: '15%',
        },
        {
          text: 'Ativo',
          value: 'active',
          width: '5%',
        },
        {
          text: '',
          value: 'menu',
          sortable: false,
          width: '5%',
        },
      ]
    },
    items() {
      if (!this.search) return this.localProductGroups
      const searchRegex = diacriticSpaceSensitiveRegex(this.search)
      return this.localProductGroups.filter((productGroup) => {
        if (productGroup.name.match(searchRegex)) return true
        if (productGroup.products?.some((product) => product.name.match(searchRegex) || product.sku === this.search)) return true
        return false
      })
    },
  },
  watch: {
    search() {
      this.options.page = 1
    },
    productGroups(val) {
      this.localProductGroups = val
    },
  },
  mounted() {
    if (this.productGroups) this.localProductGroups = this.productGroups
  },
  methods: {
    addProductGroup(productGroup) {
      this.localProductGroups.unshift(productGroup)
      this.$emit('update:product-groups', this.localProductGroups)
    },
    editProductGroup(item) {
      const index = this.localProductGroups.findIndex((productGroup) => productGroup.uuid === item.uuid)
      if (index < 0) {
        this.$snackbar({ message: `Erro ao editar grupo de produtos.`, snackbarColor: 'error' })
      }
      this.$set(this.localProductGroups, index, item)
      this.$emit('update:product-groups', this.localProductGroups)
    },
    removeItem(item) {
      this.localProductGroups = this.localProductGroups.filter((productGroup) => productGroup.uuid !== item.uuid)
      this.$emit('update:product-groups', this.localProductGroups)
    },
    editItem(item) {
      this.isEditingProduct = true
      this.selectedProductGroup = item
      this.$emit('update:product-groups', this.localProductGroups)
    },
  },
}
</script>

<style lang="scss" scoped>
.td-img {
  width: 40px;
  height: 40px;
}
.error--text {
  font-size: 12px;
}
</style>
